import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from "@ag-grid-enterprise/all-modules";
import { OptDataComponent } from '../opt-data.component';
import { SharedService } from 'src/app/util/shared.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DependenciesmodalComponent } from 'src/app/util/dependenciesmodal/dependenciesmodal.component';
import { Constants } from 'src/app/util/constants';

@Component({
  selector: 'app-delete-cell',
  template: `<button type="button" class="btn btn-sm btn-outline-dark py-0 my-1 px-1 border-0"
            (click)="onDeleteButtonClick()">
            <i class="far fa-trash-alt" aria-hidden="true"></i>
            </button>`,
  styleUrls: []
})
export class DeleteCellComponent implements OnInit, ICellRendererAngularComp {

  public attribute: any;
  public componentParent: OptDataComponent;
  private cellData;
  public bsModalRef: BsModalRef;

  constructor(private sharedService: SharedService,private modalService: BsModalService) { }

  ngOnInit() {
  }

  refresh(params: any): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.cellData = params.data;
    this.componentParent = params.context.componentParent;
    if (params.data != undefined) {
      this.attribute = params.data;
    } else {
      this.attribute = params.value;
    }
  }

  dependenciesModalWithComponent(header: String, dflag: boolean, cflag: boolean) {
    const initialState = {
      headerTitle: header,
      delFlag: dflag, 
      cancelFlag: cflag,
      checkboxVal: false
    };
    this.sharedService.setFileId(this.cellData.id);
    this.sharedService.setFileType("OperatingData");
          this.sharedService.setAction("getDependencies");
    this.sharedService.setDependencyMessageType(Constants.DEPENDENCY_MESSAGE_TYPE.DELETE);
		localStorage.setItem("isDelete", "true");
    this.sharedService.setParent(this.componentParent);
    this.bsModalRef = this.modalService.show(DependenciesmodalComponent, { initialState, class: 'modal-lg' });
    console.log("dflag= " + dflag);
    console.log("cflag= " + cflag);
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  onDeleteButtonClick() {
			this.dependenciesModalWithComponent('Delete Conflicts Operating Data', false, true);
  }

}
